var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
import { ReactElementFactory, SurveyElementBase } from "survey-react-ui";
import { TabJsonEditorErrorsComponent } from "./JsonEditorTextarea";
var TabJsonEditorAceComponent = /** @class */ (function (_super) {
    __extends(TabJsonEditorAceComponent, _super);
    function TabJsonEditorAceComponent(props) {
        var _this = _super.call(this, props) || this;
        _this.aceEditorrRef = React.createRef();
        return _this;
    }
    TabJsonEditorAceComponent.prototype.getStateElement = function () {
        return this.model;
    };
    Object.defineProperty(TabJsonEditorAceComponent.prototype, "model", {
        get: function () {
            return this.props.data;
        },
        enumerable: false,
        configurable: true
    });
    TabJsonEditorAceComponent.prototype.componentDidMount = function () {
        this.model.init(ace.edit(this.aceEditorrRef.current));
    };
    TabJsonEditorAceComponent.prototype.renderElement = function () {
        var errors = React.createElement(TabJsonEditorErrorsComponent, { data: this.model });
        return (React.createElement("div", { className: "svc-creator-tab__content" },
            React.createElement("div", { className: "svc-json-editor-tab__content" },
                React.createElement("div", { className: "svc-json-editor-tab__ace-editor", ref: this.aceEditorrRef }),
                errors)));
    };
    return TabJsonEditorAceComponent;
}(SurveyElementBase));
export { TabJsonEditorAceComponent };
ReactElementFactory.Instance.registerElement("svc-tab-json-editor-ace", function (props) {
    return React.createElement(TabJsonEditorAceComponent, props);
});
